import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IIdAckResponse } from '../ack-schema';
import { idAckResponseSchema } from '../ack-schema';
import type { ICollectionCreditBody } from '../credit-body-schema';

export async function addCollectionCreditApi(
  collectionId: number,
  body: ICollectionCreditBody,
): Promise<IValidatedResponse<IIdAckResponse>> {
  return postRequest<IIdAckResponse>({
    path: `/sys/collections/${collectionId}/credits/v1`,
    body,
    schema: idAckResponseSchema,
  });
}
